<template>
  <a-modal :destroyOnClose="true"
    width="1000px"
    v-model="visible"
    :title="$t('部门成员')">
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">  
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <DeptUserAddModal ref="content" @ok="handleRefresh(true)" />
  </a-modal>
</template>
<script>
import { getLabelFromOptions } from '@/utils/dictUtils'
import { getDeptMembers, removeMembers } from '@/api/system/dept'
import DeptUserAddModal from './DeptUserAddModal.vue'
import { UserStatusOptions } from '../config/UserConfig'

export default {
  components: {
    DeptUserAddModal
  },
  data() {
    return {
      visible: false,
      dept: {},
      queryParams: {},
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('用户名称'),
          dataIndex: 'userName',
        },
        {
          title: this.$t('账户名'),
          dataIndex: 'loginName',
        },
        {
          title: this.$t('账号状态'),
          dataIndex: 'status',
          customRender: (text) => {
            return getLabelFromOptions(text, UserStatusOptions, text)
          }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    show(dept) {
      this.dept = { ...dept }
      this.dataSource = []
      this.pagination.current = 1
      this.pagination.total = 0
      this.handleRefresh()
      this.visible = true
    },
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getDeptMembers({ ...params, deptId: this.dept.id }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleAdd() {
      this.$refs.content.show(this.dept)
    },
    handleDelete(record) {
      removeMembers([{ deptId: this.dept.id, userId: record.id }]).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>